module.exports = __webpack_public_path__ + "static/media/445767986_1315365869421704_8315769971091493096_n.28d11600.jpg";